

































































































































































































import store from './store'
import {
    // touchScreen,
    update
} from './mixins/mixins'
import {
    platform,
    linking
} from './mla-shared'
import { openLinkInBrowser } from '@/mla-shared'
const version = require('../package.json').version

export default {
    mixins: [update], // touchScreen
    data(this: any) {
        return {
            drawer: null,
            // isTouchScreen: this.detect(),
            platform: platform(),
            version: version,
            offset: window.pageYOffset,
            disable: false,
            clearLocalStorage: false,
            tabs: [
                { name: 'Home', path: '/', icon: 'home' },
                { name: 'Tool', path: 'tool', icon: 'build' },
                { name: 'Acknowledgements', path: 'acknowledgements', icon: 'star' }
            ],
            underMaintenance: false,
            breakpoint: this.$vuetify.breakpoint
        }
    },
    methods: {
        resetData: function (this:any) {
            store.dispatch('resetState', this.clearLocalStorage)
            this.clearLocalStorage = false
            // this.$router.push({ name: 'tool' })
        },
        resetDisable: function (this:any) {
            if (this.disable) {
                store.dispatch('resetDisable', true)
            }
        },
        etools() {
            openLinkInBrowser('https://etools.mla.com.au/');
        },
        support() {
            linking({
                operation: 'openURL',
                openURL: 'mailto:tools@mla.com.au',
            });
        },
        survey() {
            openLinkInBrowser('https://forms.office.com/Pages/ResponsePage.aspx?id=HJuCo77s1EmI6U8o95r6Eb5jKcqch21Kp-7SYRq4csRUQ1dDQ1FCQllQTlUxS0JXMDJFSjNDVTA2OC4u');
        }
    },
    mounted() {
        window.onscroll = () => {
            (this as any).offset = window.pageYOffset;
        }
        // console.log(this.breakpoint)
    },
    destroyed() {
        window.onscroll = null;
    },
    store
}
